var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveAllFromBookmarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58549 6.73595L10.184 1.50394C10.2596 1.35253 10.3759 1.22517 10.5199 1.13616C10.6639 1.04715 10.8298 1 10.9991 1C11.1684 1 11.3343 1.04715 11.4783 1.13616C11.6223 1.22517 11.7386 1.35253 11.8142 1.50394L14.4127 6.73595L20.2218 7.57995C20.3893 7.60318 20.547 7.67304 20.6767 7.78156C20.8064 7.89008 20.9031 8.03289 20.9555 8.19368C21.008 8.35447 21.0142 8.52677 20.9734 8.69091C20.9326 8.85504 20.8465 9.00441 20.7248 9.12195L16.5221 13.192L17.5143 18.942C17.6413 19.68 16.8611 20.242 16.194 19.894L10.9991 17.178L5.80317 19.894C5.13705 20.243 4.35691 19.68 4.48393 18.941L5.47611 13.191L1.27336 9.12095C1.15232 9.00333 1.06672 8.85411 1.02628 8.69027C0.985836 8.52642 0.992179 8.35452 1.04459 8.1941C1.09699 8.03368 1.19336 7.89117 1.32273 7.78278C1.45211 7.67439 1.6093 7.60447 1.77645 7.58095L7.58549 6.73595Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 15,
    r: 5.5,
    fill: "#333333",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 14H14.75C14.5511 14 14.3603 14.1054 14.2197 14.2929C14.079 14.4804 14 14.7348 14 15C14 15.2652 14.079 15.5196 14.2197 15.7071C14.3603 15.8946 14.5511 16 14.75 16H19.25C19.4489 16 19.6397 15.8946 19.7803 15.7071C19.921 15.5196 20 15.2652 20 15C20 14.7348 19.921 14.4804 19.7803 14.2929C19.6397 14.1054 19.4489 14 19.25 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveAllFromBookmarks);
export default __webpack_public_path__ + "static/media/RemoveAllFromBookmarks.5b60643a7bb387c5217088fb954c87d5.svg";
export { ForwardRef as ReactComponent };